<template lang="pug">
    layout-modal
        picker(v-model="emoji")
</template>

<script>
import Picker from "@/components/emojis/Picker";

export default {
	components: {
		Picker
	},
	props: {
		icon: {
			type: Object,
			default: () => ({
				type: null,
				value: null
			})
		}
	},
	computed: {
		emoji: {
			get() {
				return this.icon.value;
			},
			set(value) {
				this.$vuedals.close({
					type: "emoji",
					value
				});
			}
		}
	},
	methods: {
		async selectedEmoji(emoji) {
			this.$vuedals.close({
				type: "emoji",
				value: emoji
			});
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/classroom/create/AvatarSelector/Emojis.vue